module.exports = __webpack_public_path__ + "img/web1_3.9b145db0.jpg";